import React from 'react'

const RepairCopy = () => (
    <>
        <p>While studying audio engineering in college, Bruce joined the studio maintenance department and quickly took responsibility for maintaining all the college’s tape machines. Among his charges were 3 Studer A827 24 track machines, a Studer B67 and B77, an Otari MX5050, and an Otari MTR-10.</p>
        <p>This talent for electronics repair has allowed Bruce to maintain and repair all his own audio equipment (and even build a few pieces from scratch), and he can repair yours, too.</p>
        <p>BSK Mastersound provides maintenance and repair for all manner of electronic audio equipment, including tape machines, mixing boards, turntables, and pretty much anything else with a circuit board. Bruce can perform turntable setup and cartridge alignment, as well as tape machine cleaning, restoration, and calibration. Chances are, if you have electronic equipment that’s not working properly, BSK Mastersound can get it fixed.</p>
        <p>To start your inquiry, select a category.</p>
    </>
)

export default RepairCopy
